import styled from "styled-components";

export const BagNameBox = styled.div`
    font-weight: ${props => props.theme.fontWeight.semiBold};
    text-align: center;
`